import Controller from '@ember/controller';
import { tracked } from '@glimmer/tracking';

export default class MobileMetricsController extends Controller {
	override queryParams = ['state'];

	@tracked state: string | null = null;
}
